import React from 'react';
import { Select as AntSelect } from 'antd';

export default function SelectInput(props) {
  return <AntSelect dropdownMatchSelectWidth={false} {...props} />;
}

SelectInput.Option = AntSelect.Option;
